import React, { useEffect } from 'react';
import Layout from '../common/Layout';
import useScan from '../../hooks/useScan';
import { CardTotal } from './CardTotal/CardTotal';
import { useStyles } from './styles';
import { GraphicDonut } from './GraphicDonut/GraphicDonut';
import { getDashboardData } from '../../redux/dashboard/thunks';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../common/Loading';
import { People, House, VpnKey } from '@material-ui/icons';
import { Card, Box, Typography } from '@material-ui/core';
import ButtonBarcode from './../common/ButtonBarcode/index';
import Barcode from '../common/Barcode';

const Dashboard = () => {
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();
  const {
    loading,
    data: { loans, properties, users, keys },
  } = useSelector((state: any) => state.dashboard);
  const { type, name, id } = useSelector((state: any) => state.auth);
  const barcode = `USR-X-${id}`;

  useEffect(() => {
    setDestination('act-l-das', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getDashboardData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const classes = useStyles();
  return (
    <Layout>
      {loading ? (
        <Loading />
      ) : (
        <>
          {type < 3 ? (
            <div className={classes.container}>
              <div className={classes.gridArea}>
                {properties?.length > 0 && (
                  <CardTotal
                    list={properties}
                    title='Total Propiedades registradas'
                    color='primary'
                    icon={House}
                  />
                )}
                <Card>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-evenly',
                      pt: 1,
                      fontSize: '12px',
                    }}
                  >
                    <Typography color='textSecondary' variant='inherit'>
                      ACCIONES PRINCIPALES
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-evenly',
                      p: 1,
                    }}
                  >
                    <Box
                      sx={{ textAlign: 'left', width: '200px', padding: '0px' }}
                    >
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        PRESTAMOS
                      </Box>
                      <a href='/loans/new'>
                        <ButtonBarcode id='' src='/barcodes/act-a-loa.png' />
                      </a>
                    </Box>
                    <Box sx={{ textAlign: 'left', width: '200px' }}>
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        {' '}
                        DEVOLUCIONES
                      </Box>
                      <a href='/repayments'>
                        <ButtonBarcode id='' src='/barcodes/act-a-rep.png' />
                      </a>
                    </Box>
                  </Box>
                </Card>

                {keys?.length > 0 ? (
                  <GraphicDonut listData={keys} title='Estado de llaves' />
                ) : (
                  ''
                )}
                {loans?.length > 0 ? (
                  <GraphicDonut listData={loans} title='Total de Prestamos' />
                ) : (
                  ''
                )}
                {keys?.length > 0 && (
                  <CardTotal
                    list={keys}
                    title='Total LLaves registradas'
                    color='green'
                    icon={VpnKey}
                  />
                )}
                {users?.length > 0 && (
                  <CardTotal
                    list={users}
                    title='Total Usuarios'
                    color='secondary'
                    progress
                    icon={People}
                  />
                )}
              </div>
            </div>
          ) : (
            <div className={classes.container}>
              <h2>Bienvenid@ {name} al sistema de administración de llaves</h2>
              <div className={classes.gridArea}>
                <Card>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-evenly',
                      pt: 1,
                      fontSize: '12px',
                    }}
                  >
                    <Typography color='textSecondary' variant='inherit'>
                      TU CODIGO DE BARRAS E IDENTIFICACION EN EL SISTEMA
                    </Typography>
                  </Box>
                  <Barcode barcode={barcode} />
                </Card>
                <Card>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-evenly',
                      pt: 1,
                      fontSize: '12px',
                    }}
                  >
                    <Typography color='textSecondary' variant='inherit'>
                      ACCIONES PENDIENTES
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      width: '100%',
                      justifyContent: 'space-evenly',
                      p: 1,
                    }}
                  >
                    <Box
                      sx={{ textAlign: 'left', width: '200px', padding: '0px' }}
                    >
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        Proximamente
                      </Box>
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        Solicitud de prestamos de llaves
                      </Box>
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        Comentarios sobre llaves en la visita
                      </Box>
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        Tips de llaves para la visita
                      </Box>
                    </Box>
                    <Box sx={{ textAlign: 'left', width: '200px' }}>
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        Proximamente
                      </Box>
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        Historial de mis prestamos
                      </Box>
                      <Box sx={{ fontSize: '12px', textAlign: 'center', p: 1 }}>
                        Historial de mis devoluciones
                      </Box>
                    </Box>
                  </Box>
                </Card>
              </div>
            </div>
          )}
        </>
      )}
    </Layout>
  );
};

export default Dashboard;
